import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

import { FsReverseGeocodeResults, SnSearchResponse } from '@lib/api/entities';
import { t } from '@lib/translation/helpers/translation.helper';

@Injectable({ providedIn: 'root' })
export class SnSearchAPI {
  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _toastrService: ToastrService,
  ) {}

  public search(search: string): Observable<SnSearchResponse> {
    const modifiedSearch = search?.replace(/\//g, '&');

    const params: Params = { search: modifiedSearch };

    return this._httpClient
      .get('/api/searcher/', { params })
      .pipe(map((response) => new SnSearchResponse(response)));
  }

  public geocode(search: string): Observable<any> {
    const params: Params = { search };

    return this._httpClient.get('/api/searcher/geocode/', { params }).pipe(
      map((response: any[]) => {
        return response.map((result) => {
          return new FsReverseGeocodeResults(result);
        });
      }),
    );
  }

  public reverseGeocode(
    coordinates: number[],
    shouldShowErrorToast: boolean = true,
  ): Observable<any> {
    const params: Params = { x: coordinates[0], y: coordinates[1] };

    return this._httpClient.get('/api/searcher/reverse_geocode/', { params }).pipe(
      map((response: any[]) => {
        if (!response.length && shouldShowErrorToast) {
          this._toastrService.error(t('sentry.search.errors.noResults'));
        }
        return response.map((result) => {
          return new FsReverseGeocodeResults(result);
        });
      }),
    );
  }
}
